export const accountTypeLabels: Record<string, string> = {
  bank: 'Banco',
  cash: 'Dinheiro',
  digital_wallet: 'Carteira Digital',
  checking: 'Conta Corrente',
  savings: 'Poupança',
  credit_card: 'Cartão de Crédito',
  investment: 'Investimento',
};

export const accountTypeColors: Record<string, string> = {
  bank: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
  cash: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200',
  digital_wallet: 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200',
  checking: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
  savings: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
  credit_card: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200',
  investment: 'bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-200',
};

export const accountTypeIcons: Record<string, string> = {
  bank: '🏦',
  cash: '💰',
  digital_wallet: '💳',
  checking: '🟢',
  savings: '🔵',
  credit_card: '🔴',
  investment: '📊',
};

export function getAccountTypeLabel(type: string): string {
  return accountTypeLabels[type] || type;
}

export function getAccountTypeColor(type: string): string {
  return accountTypeColors[type] || 'bg-gray-100 text-gray-800';
}

export function getAccountTypeIcon(type: string): string {
  return accountTypeIcons[type] || '💼';
}
